module.exports = __webpack_public_path__ + "static/appstore-f6853d96f3f65d94122ab2a574d6e430.svg";